module.exports = __webpack_public_path__ + "img/icons8_price-tag.15044636.svg";